const layouts = {
  development: {
    paddingTopMain: "90px",
    paddingTopLang: "132px",
    paddingTopMain991: "72px",
    paddingTopMain767: "72px",
    paddingTopMain575: "57px",
  },
  production: {
    paddingTopMain: "66px",
    paddingTopLang: "98px",
    paddingTopMain991: "47px",
    paddingTopMain767: "47px",
    paddingTopMain575: "33px",
  },
};

export default layouts[process.env.NODE_ENV] || layouts.development;
